import { useEffect, useRef } from 'react';
import { KeyCode } from "./keyCode";
export function useEnterKeyStopPropagation(config) {
    var _a;
    var internalRef = useRef(null);
    var ref = (config === null || config === void 0 ? void 0 : config.ref) ? config.ref : internalRef;
    var hasStopPropagation = (_a = config === null || config === void 0 ? void 0 : config.hasStopPropagation) !== null && _a !== void 0 ? _a : true;
    useEffect(function () {
        var _a;
        var keyDownHandler = function (e) {
            var _a;
            if (hasStopPropagation && e.keyCode === KeyCode.Enter) {
                e.stopPropagation();
                (_a = config === null || config === void 0 ? void 0 : config.onKeyEnterPress) === null || _a === void 0 ? void 0 : _a.call(config, e);
                return;
            }
        };
        (_a = ref.current) === null || _a === void 0 ? void 0 : _a.addEventListener('keydown', keyDownHandler);
        return function () {
            var _a;
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('keydown', keyDownHandler);
        };
    }, [hasStopPropagation, config === null || config === void 0 ? void 0 : config.onKeyEnterPress, ref]);
    return {
        ref: ref
    };
}
//# sourceMappingURL=useEnterKeyStopPropagation.js.map